module.exports = __webpack_public_path__ + "img/vpn-logo.026f792d.webp";